import { init } from '@fullstory/browser';

import { ENV } from '../../shared/ENV';

export const initFullStory = (): void => {
  // can remove staging from here later
  if (!['production', 'production-beta', 'staging'].includes(ENV.VITE_ENV)) {
    return;
  }
  init({ orgId: ENV.VITE_FULLSTORY_ORG_ID });
};
